// src/components/layout/Header.tsx
import { MonitorCheck } from "lucide-react";
import { Link } from "react-router-dom";
import LanguageSelector from "../language/LanguageSelector";

const Header = () => {
  return (
    <header className="sticky top-0 z-50 w-full py-4 px-6 bg-gradient-to-r from-purple-500/10 to-blue-500/10 backdrop-blur-lg border-b border-white/10">
      <div className="max-w-4xl mx-auto flex items-center justify-between">
        <Link 
          to="/" 
          className="flex items-center space-x-2.5 hover:opacity-90 transition-opacity group"
          aria-label="White Screen Online Home"
        >
          <div className="flex items-center justify-center w-8 h-8 rounded-lg bg-gradient-to-br from-purple-500 to-blue-500 shadow-lg group-hover:shadow-purple-500/25 transition-shadow duration-300">
            <MonitorCheck className="h-6 w-6 text-white" />
          </div>
          <span className="font-bold text-2xl tracking-tight bg-gradient-to-r from-purple-500 to-blue-500 bg-clip-text text-transparent">
            WS Online
          </span>
        </Link>

        <div className="flex items-center">
          <LanguageSelector />
        </div>
      </div>
    </header>
  );
};

export default Header;